import apiClient from "../../utils/apiClient";
import apiService from "../apiService/apiService";

const GET_MASTER_CLASS_BY_ID = "master-classes";

const getMasterClasses = (page, searchTerm) => {
    const params = {
        'page': page,
        's': searchTerm,
    };

    const queryString = apiService.getRequestParams(params);
    let url = `master-classes${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
}

const getSpeakerMasterClasses = (page, searchTerm) => {
    const params = {
        'page': page,
        's': searchTerm,
    };

    const queryString = apiService.getRequestParams(params);
    let url = `speaker/master-classes${queryString ? '?' + queryString : ''}`;

    return apiClient.get(url);
}

const getSpeakerMasterClassData = (id) => {
    return apiClient.get(`speaker/master-classes/${id}`);
}

const getSingleMasterClassData = (id) => {
    const url = `${GET_MASTER_CLASS_BY_ID}/${id}`;
    return apiClient.get(url);
};

const rateMasterClass = (id, rating) => {
    const data = {
        rating: rating
    };
    const url = `master-classes/${id}/rate`;

    return apiClient.post(url, data);
};

const getRecommendations = () => {
    let url = `master-classes/recommendations`;

    return apiClient.get(url);
}

const watchAllLessons = (id) => {
    const url = `master-classes/${id}/watch-all`;
    return apiClient.post(url);
};

const completeMasterclass = (id) => {
    const url = `master-classes/${id}/complete`;
    return apiClient.post(url);
};

const getMasterClassPreviewData = (id) => {
    const url = `master-classes/${id}/preview`;
    return apiClient.get(url);
};

const playbookDownloadLog = (id) => {
    const url = `master-classes/${id}/playbook-download`;
    return apiClient.post(url);
};

const downloadCertificate = (id) => {
    const url = `master-classes/${id}/certificate`;
    return apiClient.get(url);
};

const getMasterClassCertificate = (id) => {
    const url = `master-classes/certificates/${id}`;
    return apiClient.get(url);
};

const shareOnLinkedin = (id, formData) => {
    const url = `master-classes/certificates/${id}/share-certificate`;
    return apiClient.post(url, formData);
};

const addToFavorite = (formData) => {
    const url = `master-classes/favorites`;
    return apiClient.post(url, formData);
};

const removeFromFavorite = (id) => {
    const url = `master-classes/favorites/${id}`;
    return apiClient.delete(url);
};

const getFavorites = () => {
    const url = `master-classes/favorites`;
    return apiClient.get(url);
};

export const MasterClassService = {
    getSingleMasterClassData,
    getMasterClasses,
    rateMasterClass,
    getSpeakerMasterClasses,
    getSpeakerMasterClassData,
    getRecommendations,
    getMasterClassPreviewData,
    playbookDownloadLog,
    downloadCertificate,
    getMasterClassCertificate,
    shareOnLinkedin,
    addToFavorite,
    removeFromFavorite,
    getFavorites,
    watchAllLessons,
    completeMasterclass
};